var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('WppContactsTable',{ref:"contactsTable",on:{"changed":function($event){return _vm.$refs.groupsTable.refresh()}}}),_vm._v(" "),_c('WppGroupsTable',{ref:"groupsTable",on:{"changed":function($event){return _vm.$refs.contactsTable.refresh()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }